import styled from 'styled-components'

const justify = {
  start: 'flex-start',
  end: 'flex-end',
  between: 'space-between',
}

const FinanceActionBar = styled.div<{
  $align?: 'start' | 'end' | 'between'
  $wrap?: boolean
  $sticky?: boolean
}>`
  display: flex;
  gap: 10px;
  flex-wrap: ${(props) => (props.$wrap === false ? 'nowrap' : 'wrap')};
  justify-content: ${(props) => justify[props.$align || 'start']};
  align-items: center;
  ${(props) =>
    props.$sticky
      ? `position: sticky; bottom: 0; background: rgba(255,255,255,0.96); padding-top: 12px; z-index: 2;`
      : ''}
`

export default FinanceActionBar
